import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { createSchedule, deleteSchedule, updateSchedule } from '@/api/schedules';
import { listSchedules } from '@/api/schedules';
import type { ScheduleCreate } from '@/types';

export function useSchedules() {
  return useQuery({
    queryKey: ['schedules'],
    queryFn: () => listSchedules(),
    refetchInterval: 15_000, // next_run_at / last_status change as the poller fires
  });
}

export function useCreateSchedule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ScheduleCreate) => createSchedule(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schedules'] }),
  });
}

export function useUpdateSchedule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<ScheduleCreate> }) =>
      updateSchedule(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schedules'] }),
  });
}

export function useDeleteSchedule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteSchedule(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schedules'] }),
  });
}
